{
  "language": {
    "title": "Choisissez votre langue",
    "en": "Anglais",
    "nl": "Néerlandais",
    "sr": "Serbe",
    "fr": "Français",
    "de": "Allemand",
    "pt": "Portugais"
  },
  "home": {
    "welcomeMessage": "Bonjour, que venez-vous faire aujourd'hui?",
    "checkIn": "Enregistrement",
    "independentManualCheckIn": "Pas de rendez-vous",
    "integratedManualCheckIn": "Enregistrement manuel",
    "checkOut": "Départ",
    "manualCheckOut": "Départ manuel",
    "parcelDelivery": "Livraison de colis",
    "foodDelivery": "Livraison de nourriture",
    "callReception": "Appeler la réception",
    "overview": "Aperçu",
    "unavailable": "La réception est actuellement indisponible."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Choisissez une option pour vous enregistrer",
        "manual": "Enregistrement manuel",
        "code": "Enregistrement avec code PIN/QR"
      },
      "checkout": {
        "title": "Choisissez une option pour partir",
        "manual": "Départ avec nom",
        "code": "Départ avec code PIN/QR"
      }
    },
    "title": "En attente de scanner votre code QR.<br/>Pas de code QR? Pas de problème.",
    "orText": "OU",
    "qrScanner": {
      "checkin": {
        "title": "Choisissez une option pour vous enregistrer"
      },
      "checkout": {
        "title": "Choisissez une option pour partir"
      },
      "btn": "Scannez votre code QR"
    },
    "pinCode": "Entrez votre code PIN",
    "manually": {
      "checkin": "Pas d'identifiants?"
    },
    "status": {
      "idle": {
        "title": "Votre code est en cours de scan.",
        "message": "Veuillez patienter..."
      },
      "loading": {
        "title": "Votre code est en cours de scan.",
        "message": "Veuillez patienter..."
      },
      "error": {
        "title": "Votre code est invalide.",
        "message": "Veuillez réessayer!"
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Vous êtes enregistré avec succès.",
            "message": "Merci."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Vous êtes enregistré avec succès.",
              "message": "Merci."
            },
            "email-sms": {
              "title": "Vous êtes enregistré avec succès.",
              "message": "Votre contact a été notifié."
            },
            "call-ping": {
              "title": "Vous êtes enregistré avec succès.",
              "message": "Une connexion téléphonique est établie avec votre contact."
            }
          },
          "Employee": {
            "title": "Vous êtes enregistré avec succès.",
            "message": "Merci."
          },
          "Visitor": {
            "title": "Vous êtes enregistré avec succès.",
            "message": "Merci."
          }
        },
        "checkout": {
          "default": {
            "title": "Vous êtes parti avec succès.<br/>",
            "message": "À bientôt."
          },
          "MeetingAttendee": {
            "title": "Vous êtes parti avec succès.",
            "message": "À bientôt."
          },
          "Employee": {
            "title": "Vous êtes parti avec succès.",
            "message": "À bientôt."
          },
          "Visitor": {
            "title": "Vous êtes parti avec succès.",
            "message": "À bientôt."
          }
        }
      }
    }
  },
  "manualCheckin": {
    "title": "Veuillez remplir.",
    "subtitle": "Remarque - Tous les champs marqués d'un * doivent être remplis",
    "noOption": "Aucune option",
    "btn": "Enregistrement",
    "placeholder": {
      "name": "Votre nom *",
      "email": "Votre e-mail *",
      "phone": "Numéro de mobile",
      "contactName": "Nom de votre contact *"
    },
    "error": {
      "required": "Vous n'avez pas rempli ce champ",
      "name": "Nom invalide",
      "email": "Adresse e-mail invalide",
      "phone": "Numéro de mobile invalide"
    },
    "status": {
      "loading": {
        "title": "Veuillez patienter...",
        "message": "Votre contact est en cours de notification."
      },
      "success": {
        "no-email-sms": {
          "title": "Vous êtes enregistré avec succès.",
          "message": "Merci."
        },
        "email-sms": {
          "title": "Vous êtes enregistré avec succès.",
          "message": "Votre contact a été notifié."
        },
        "call-ping": {
          "title": "Vous êtes enregistré avec succès.",
          "message": "Une connexion téléphonique est établie avec votre contact."
        }
      },
      "error": {
        "title": "Une erreur s'est produite.",
        "message": "Veuillez réessayer!"
      }
    }
  },
  "manualCheckout": {
    "title": "Entrez votre nom pour partir",
    "btn": "Départ",
    "form": {
      "placeholder": {
        "name": "Votre nom complet *"
      },
      "loading": "Chargement...",
      "noOptions": "Aucune option"
    },
    "error": {
      "required": "Vous n'avez pas rempli ce champ",
      "name": "Nom invalide"
    },
    "status": {
      "loading": {
        "title": "Nous scannons vos informations.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "title": "Vous êtes parti avec succès.",
        "message": "Merci et bonne journée."
      },
      "error": {
        "title": "Une erreur est survenue lors du départ.",
        "message": "Veuillez réessayer!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Voulez-vous notifier votre contact?",
      "email-sms": "Nous avons envoyé un e-mail/SMS à votre contact.<br/>Voulez-vous les notifier en plus?"
    },
    "callBtn": "Appel",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Appel vidéo",
    "noBtn": "Annuler",
    "cancelBtn": "Annuler l'appel",
    "status": {
      "connecting": {
        "title": "Établissement de la connexion.<br/>Veuillez patienter...",
        "message": ""
      },
      "ringing": {
        "title": "Appel en cours<br/>Veuillez patienter...",
        "message": ""
      },
      "ringingReception": {
        "title": "Appel en cours avec la réception.<br/>Veuillez patienter...",
        "message": ""
      },
      "open": {
        "title": "Appel en cours.",
        "message": ""
      },
      "close": {
        "title": "Appel terminé.<br/>Veuillez attendre votre contact.",
        "message": ""
      },
      "closeReception": {
        "title": "Appel terminé.",
        "message": ""
      },
      "error": {
        "title": "Échec de l'appel.<br/>Ressayer?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Nous notifiions le contact.",
        "message": "Veuillez patienter..."
      },
      "loading": {
        "title": "Nous notifiions le contact.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "title": "SMS envoyé. Le contact est notifié.",
        "message": "Merci!"
      },
      "error": {
        "title": "SMS non envoyé.",
        "message": "Veuillez réessayer!"
      }
    }
  },
  "videoCall": {
    "title": "Appel vidéo",
    "endCall": "TERMINER L'APPEL",
    "status": {
      "idle": {
        "title": "Nous créons une salle vidéo.",
        "message": "Veuillez patienter..."
      },
      "loading": {
        "title": "Nous créons une salle vidéo.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "title": "La salle vidéo a été créée avec succès.",
        "message": "Entrée dans la salle..."
      },
      "error": {
        "title": "La salle vidéo n'a pas pu être créée avec succès.",
        "message": "Veuillez réessayer !"
      }
    }
  },
  "packageDelivery": {
    "title": "C'est gentil de votre part de livrer un colis !",
    "subtitle": "Sélectionnez et informez le destinataire",
    "subtitle1": "Appuyez sur le bouton ci-dessous pour nous faire savoir que vous êtes ici !",
    "subtitle2": "Vous pouvez laisser le colis au comptoir.",
    "input": {
      "label": {
        "contact": "Pour qui est le colis"
      },
      "error": {
        "contact": {
          "required": "Vous n'avez pas rempli ce champ"
        }
      }
    },
    "button": {
      "submit": "Notifier"
    },
    "status": {
      "loading": {
        "title": "Nous informons le contact.<br/>Veuillez patienter...",
        "message": ""
      },
      "success": {
        "no-email-sms": {
          "title": "Merci pour votre livraison !",
          "message": ""
        },
        "email-sms": {
          "title": "Le contact a été informé.<br/>Merci pour votre livraison !",
          "message": ""
        },
        "call-ping": {
          "title": "Merci pour votre livraison !",
          "message": "Une connexion téléphonique va maintenant être établie avec votre personne de contact."
        }
      },
      "error": {
        "title": "Une erreur s'est produite.<br/>Veuillez réessayer !",
        "message": ""
      }
    }
  },
  "foodDelivery": {
    "title": "Quelle gentillesse de votre part de livrer de la nourriture !",
    "subtitle": "Sélectionnez et informez le destinataire",
    "subtitle1": "Appuyez sur le bouton ci-dessous pour nous faire savoir que vous êtes ici !",
    "subtitle2": "Vous pouvez laisser la nourriture au comptoir.",
    "input": {
      "label": {
        "contact": "Pour qui est la nourriture"
      },
      "error": {
        "contact": {
          "required": "Vous n'avez pas rempli ce champ"
        }
      }
    },
    "button": {
      "submit": "Notifier"
    },
    "status": {
      "loading": {
        "title": "Nous informons le contact.<br/>Veuillez patienter !",
        "message": ""
      },
      "success": {
        "no-email-sms": {
          "title": "Merci pour votre livraison !",
          "message": ""
        },
        "email-sms": {
          "title": "Le contact a été informé.<br/>Merci pour votre livraison !",
          "message": ""
        },
        "call-ping": {
          "title": "Merci pour votre livraison !",
          "message": "Une connexion téléphonique va maintenant être établie avec votre personne de contact."
        }
      },
      "error": {
        "title": "Une erreur s'est produite.<br/>Veuillez réessayer !",
        "message": ""
      }
    }
  },
  "QRCodeScanner": {
    "title": "Veuillez scanner votre code QR",
    "subtitle": "Alignez le code QR à l'intérieur des coins rouges et gardez votre téléphone stable."
  },
  "common": {
    "backBtn": "Retour"
  },
  "previewPDF": {
    "page": {
      "of": "de",
      "previous": "Précédent",
      "next": "Suivant"
    },
    "button": {
      "cancel": "Annuler",
      "accept": "Accepter",
      "next": "Suivant"
    },
    "title": {
      "consent": "Consentement requis"
    }
  },
  "offline": {
    "title": "Hors ligne",
    "receptionMessage": "La réception est hors ligne pour le moment et ne peut pas être utilisée, veuillez vérifier la connexion Internet !",
    "check": "Êtes-vous un visiteur et souhaitez-vous parler directement à un employé ? Veuillez appeler {{receptionistPhone}}"
  },
  "overview": {
    "title": "Entrez le code pour ouvrir l'aperçu !",
    "noUsers": "Aucun utilisateur",
    "status": {
      "success": {
        "title": "Le code est valide.",
        "message": ""
      },
      "error": {
        "title": "Le code n'est pas valide.<br/>Veuillez réessayer !",
        "message": ""
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "S'il vous plaît, attendez...",
        "message": ""
      },
      "success": {
        "title": "Paiement réussi.",
        "message": ""
      },
      "error": {
        "title": "Quelque chose s'est mal passé.<br/>Veuillez réessayer!",
        "message": ""
      }
    },
    "listTitle": "Liste des personnes qui se sont enregistrées aujourd'hui mais n'ont pas effectué leur départ.",
    "page": "Page ",
    "table": {
      "head": {
        "fullName": "Nom",
        "type": "Type",
        "checkedinAt": "Enregistré à",
        "host": "Hôte"
      },
      "type": {
        "Package": "Livraison de colis",
        "Food": "Livraison de nourriture",
        "Visitor": "Visiteur",
        "MeetingAttendee": "Participant à une réunion",
        "Employee": "Employé",
        "Guest": "Invité"
      }
    },
    "confirmModal": {
      "title": "Êtes-vous sûr de vouloir procéder au départ de {{fullName}}?",
      "cancel": "Annuler",
      "checkout": "Départ"
    }
  },
  "wifi": {
    "title": "Connectez-vous au réseau Wi-Fi"
  }
}
